import * as React from 'react';
export const IcEnterpreneurial = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.38 16c-.67.67-1 2.6-1.12 3.8a.84.84 0 00.94.94c1.2-.13 3.13-.45 3.8-1.12A2.56 2.56 0 004.38 16zM21 4.09A1.001 1.001 0 0019.91 3c-.64.06-6.32.63-8.74 3a13.43 13.43 0 00-1.91 2.5 3.81 3.81 0 00-3.79.67l-2.18 2.18a1 1 0 00-.25 1 1 1 0 00.74.7l4.73 1.07 1.38 1.38L11 20.22a1 1 0 00.7.74.9.9 0 00.28 0 1 1 0 00.71-.29l2.18-2.18a3.44 3.44 0 00.91-2.48 4.003 4.003 0 00-.24-1.31A13.433 13.433 0 0018 12.83c2.37-2.42 2.94-8.1 3-8.74zm-4.2 5.23a1.5 1.5 0 110-2.12 1.51 1.51 0 010 2.12z'
      fill='currentColor'
    />
  </svg>
);
